export const COLORS = {
  PAPER: '#fbf7f0',
  PAPER_DARK: '#faf1e1',
  TEXT: '#333'
};
